import { Link } from "react-router-dom";

export const SENDTOO_LOGO = `${process.env.PUBLIC_URL || ""}/sendtoo-logo.png`;

const sizeClasses = {
  sm: "h-9 max-w-[144px]",
  md: "h-11 max-w-[180px]",
  lg: "h-14 max-w-[220px]",
  xl: "h-16 max-w-[260px]",
  "2xl": "h-[72px] max-w-[300px]",
};

export default function SendtooLogo({
  size = "md",
  className = "",
  to,
  align = "left",
}) {
  const img = (
    <img
      src={SENDTOO_LOGO}
      alt="Sendtoo"
      className={`${sizeClasses[size]} w-auto object-contain object-left block ${className}`}
    />
  );

  const wrapperClass =
    align === "center"
      ? "flex w-full justify-center items-center"
      : "inline-flex items-center";

  if (to) {
    return (
      <Link to={to} className={`${wrapperClass} flex-shrink-0`}>
        {img}
      </Link>
    );
  }

  return <span className={wrapperClass}>{img}</span>;
}
